/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `min` - minimum value of the variable in the configured interval
 * * `max` - maximum value of the variable in the configured interval
 * * `avg` - average value of the variable in the configured interval
 * * `cum` - variable integration over time [dt * variable]
 * * `cum_positive` - variable integration over time [dt * variable] in positive direction
 * * `cum_negative` - variable integration over time [dt * variable] in negative direction
 * * `current` - current value of a variable
 * * `sum` - variable summation over configured interval
 * @export
 */
export const MethodEnum = {
  MIN: "min",
  MAX: "max",
  AVG: "avg",
  CUM: "cum",
  CUM_POSITIVE: "cum_positive",
  CUM_NEGATIVE: "cum_negative",
  CURRENT: "current",
  SUM: "sum",
} as const;
export type MethodEnum = (typeof MethodEnum)[keyof typeof MethodEnum];

export function instanceOfMethodEnum(value: any): boolean {
  for (const key in MethodEnum) {
    if (Object.prototype.hasOwnProperty.call(MethodEnum, key)) {
      if (MethodEnum[key as keyof typeof MethodEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function MethodEnumFromJSON(json: any): MethodEnum {
  return MethodEnumFromJSONTyped(json, false);
}

export function MethodEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MethodEnum {
  return json as MethodEnum;
}

export function MethodEnumToJSON(value?: MethodEnum | null): any {
  return value as any;
}

export function MethodEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): MethodEnum {
  return value as MethodEnum;
}
